// Weapon icon mapping - using emoji weapons that are more appropriate
export const getWeaponIcon = (weaponName) => {
  if (!weaponName) return '🔫'; // Default gun icon
  
  const weapon = weaponName.toLowerCase();
  
  // Rifles
  if (weapon.includes('ak-47') || weapon.includes('ak47')) return '🔫';
  if (weapon.includes('m4a4') || weapon.includes('m4a1') || weapon.includes('m4a1-s')) return '🔫';
  if (weapon.includes('awp')) return '🎯'; // Sniper scope icon
  if (weapon.includes('scout') || weapon.includes('ssg')) return '🎯';
  if (weapon.includes('galil') || weapon.includes('famas') || weapon.includes('aug') || weapon.includes('sg')) return '🔫';
  
  // Pistols
  if (weapon.includes('glock') || weapon.includes('usp') || weapon.includes('p2000') || 
      weapon.includes('p250') || weapon.includes('five-seven') || weapon.includes('tec-9') || 
      weapon.includes('cz75') || weapon.includes('desert eagle') || weapon.includes('deagle') ||
      weapon.includes('dual berettas') || weapon.includes('r8 revolver')) return '🔫';
  
  // SMGs
  if (weapon.includes('mp9') || weapon.includes('mac-10') || weapon.includes('mp7') || 
      weapon.includes('ump') || weapon.includes('p90') || weapon.includes('pp-bizon') || 
      weapon.includes('mp5')) return '🔫';
  
  // Shotguns
  if (weapon.includes('nova') || weapon.includes('xm1014') || weapon.includes('sawed-off') || 
      weapon.includes('mag-7')) return '🔫';
  
  // Machine Guns
  if (weapon.includes('m249') || weapon.includes('negev')) return '🔫';
  
  // Knives
  if (weapon.includes('knife') || weapon.includes('bayonet') || weapon.includes('karambit') || 
      weapon.includes('butterfly') || weapon.includes('flip') || weapon.includes('gut') ||
      weapon.includes('huntsman') || weapon.includes('falchion') || weapon.includes('bowie') ||
      weapon.includes('shadow') || weapon.includes('daggers') || weapon.includes('ursus') ||
      weapon.includes('navaja') || weapon.includes('stiletto') || weapon.includes('talon') ||
      weapon.includes('cleaver') || weapon.includes('paracord') || weapon.includes('survival') ||
      weapon.includes('nomad') || weapon.includes('skeleton') || weapon.includes('classic')) return '🗡️';
  
  // Gloves
  if (weapon.includes('gloves') || weapon.includes('glove') || weapon.includes('wraps')) return '🧤';
  
  // Default for unknown weapons
  return '🔫';
};

// Get weapon category icon for better visual distinction
export const getWeaponCategoryIcon = (category) => {
  switch (category?.toLowerCase()) {
    case 'rifles': return '🎯';
    case 'pistols': return '🔫';
    case 'smgs': return '🔫';
    case 'shotguns': return '🔫';
    case 'machine guns': return '🔫';
    case 'knives': return '🗡️';
    case 'gloves': return '🧤';
    default: return '🔫';
  }
};
